import { ecId, type Row } from '../ability/context';
import { statusScalar } from '../actions/activity';
import { statusCasterId } from '../statuses/expiry';
import { deathStatusRows } from './cleanup';
import { deathHolders } from './departure';

/** Potential status-loss/death cascades use the roots' physical connections, including
 * lean caster projections. A linked holder's independent casts are not death inputs. */
export function deathInputMemberIds(encounter: Row, roots: readonly string[]): string[] {
    const roster = Array.isArray(encounter.encounter_creatures_arr) ? encounter.encounter_creatures_arr as Row[] : [];
    const members = new Set(roster.map(ecId)), sources = new Set(roots.map(id => id.toUpperCase()));
    const reached = new Set(sources);
    const connections = new Set<string>();
    const statuses = deathStatusRows(deathHolders([encounter, ...roster]));
    const targetId = (status: Row): string => String(statusScalar(status, 'status_target_id') ?? '').toUpperCase();
    const connectionId = (status: Row): string => String(statusScalar(status, 'status_connected_id') ?? '').toUpperCase();
    const onRoot = (status: Row): boolean => sources.has(targetId(status)) || sources.has(statusCasterId(status));
    for (const status of statuses) if (onRoot(status) && connectionId(status)) connections.add(connectionId(status));
    for (const status of statuses) {
        if (!onRoot(status) && !connections.has(connectionId(status))) continue;
        for (const id of [targetId(status), statusCasterId(status)]) if (members.has(id)) reached.add(id);
    }
    return [...reached].filter(id => members.has(id));
}
